import React, { useEffect, useState } from "react";
import { Direction } from "../../../_app/types";
import { Strategy } from "../../../store/slices/strategySlice";
import { Paper, Stack, Tab } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { precision } from "../../../utils/_precision";
import AdornmentQuoteIcon from "../../../_pages/FuturesBotCreationPage/components/AdornmentQuoteIcon";
import { TextFieldStyled } from "../../../_components/TextFieldStyled";
import AdronTypography from "../../../_components/AdronTypography";
import NumericFormatCustom from "../../../_components/NumericFormatCustom";

interface Props {
  strategy: Strategy;
  onChangeMinPrice: (value: number) => void;
  onChangeMaxPrice: (value: number) => void;
  onChangeStartPrice: (value: number) => void;
  gridDirection?: Direction;
}

const AutoStrategyRange = ({ strategy, onChangeMinPrice, onChangeMaxPrice }: Props) => {
  const theme = useTheme();

  const helperText = "Please fill out this field";

  const [stringMinPrice, setStringMinPrice] = useState<string>(String(strategy.minPrice));
  const [stringMaxPrice, setStringMaxPrice] = useState<string>(String(strategy.maxPrice));

  const handleMinPrice = (value: string) => {
    setStringMinPrice(value);
    onChangeMinPrice(Number(value));
  };
  const handleMaxPrice = (value: string) => {
    setStringMaxPrice(value);
    onChangeMaxPrice(Number(value));
  };

  useEffect(() => {
    if (!strategy.minPrice) return;
    setStringMinPrice(String(strategy.minPrice));
  }, [strategy.minPrice]);

  useEffect(() => {
    if (!strategy.maxPrice) return;
    setStringMaxPrice(String(strategy.maxPrice));
  }, [strategy.maxPrice]);

  return (
    <Paper
      elevation={0}
      className="base-adron-paper paper-light"
      style={{ backgroundColor: theme.palette.grey[400] }}
    >
      <Stack direction={"row"} justifyContent={"space-between"} sx={{ width: "100%" }} spacing={1}>
        <TextFieldStyled
          className={`textAlignRight AdronRangePrice ${
            theme.palette.mode === "dark" ? "MuiFormHelperTextDARK" : "MuiFormHelperTextLIGHT"
          }`}
          fullWidth={true}
          label="Low price"
          variant="outlined"
          value={stringMinPrice}
          helperText={(stringMinPrice === "" || Number(stringMinPrice) === 0) && helperText}
          error={stringMinPrice === "" || Number(stringMinPrice) === 0}
          size="small"
          autoComplete={"off"}
          onChange={(e) => handleMinPrice(e.target.value)}
          InputProps={{
            startAdornment: <AdornmentQuoteIcon quoteCurrencyName={strategy.quote} />,
            endAdornment: (
              <AdronTypography
                style={{ marginLeft: "6px" }}
                halfOpacity
                value={`${strategy.quote}`}
              />
            ),
            inputComponent: NumericFormatCustom as any,
            inputProps: {
              inputMode: "decimal",
              pattern: "[0-9]*",
              decimalCustom: precision(strategy.ticker.priceStep),
            },
          }}
        />
        <TextFieldStyled
          className={`textAlignRight AdronRangePrice ${
            theme.palette.mode === "dark" ? "MuiFormHelperTextDARK" : "MuiFormHelperTextLIGHT"
          }`}
          fullWidth={true}
          label="High price"
          variant="outlined"
          value={stringMaxPrice}
          helperText={(stringMaxPrice === "" || Number(stringMaxPrice) === 0) && helperText}
          error={stringMaxPrice === "" || Number(stringMaxPrice) === 0}
          size="small"
          onChange={(e) => handleMaxPrice(e.target.value)}
          type={"text"}
          autoComplete={"off"}
          InputProps={{
            style: { textAlign: "right" },
            startAdornment: <AdornmentQuoteIcon quoteCurrencyName={strategy.quote} />,
            endAdornment: (
              <AdronTypography
                style={{ marginLeft: "6px" }}
                halfOpacity
                value={`${strategy.quote}`}
              />
            ),
            inputComponent: NumericFormatCustom as any,
            inputProps: {
              inputMode: "decimal",
              pattern: "[0-9]*",
              decimalCustom: precision(strategy.ticker.priceStep),
            },
          }}
        />
      </Stack>
    </Paper>
  );
};

export default AutoStrategyRange;
